/**
 * Validation utility functions
 */

import { TASK_VALIDATION } from '../lib/config/project-config'

export const validators = {
  // Task title validation
  isValidTaskTitle: (title: string): boolean => {
    const trimmed = title.trim()
    return trimmed.length >= TASK_VALIDATION.title.minLength && trimmed.length <= TASK_VALIDATION.title.maxLength
  },

  // Task description validation
  isValidTaskDescription: (description: string): boolean => {
    if (!description) return true
    return description.length <= TASK_VALIDATION.description.maxLength
  },

  // Email validation
  isValidEmail: (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(email)
  },

  // URL validation
  isValidUrl: (url: string): boolean => {
    try {
      new URL(url)
      return true
    } catch {
      return false
    }
  },

  // UUID validation
  isValidUUID: (uuid: string): boolean => {
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
    return uuidRegex.test(uuid)
  },

  // Get validation error message for task
  getTaskTitleError: (title: string): string | null => {
    const trimmed = title.trim()
    if (trimmed.length < TASK_VALIDATION.title.minLength) {
      return `Title must be at least ${TASK_VALIDATION.title.minLength} characters`
    }
    if (trimmed.length > TASK_VALIDATION.title.maxLength) {
      return `Title must not exceed ${TASK_VALIDATION.title.maxLength} characters`
    }
    return null
  },

  getTaskDescriptionError: (description: string): string | null => {
    const plainText = description.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim()
    if (plainText && plainText.length > TASK_VALIDATION.description.maxLength) {
      return `Description must not exceed ${TASK_VALIDATION.description.maxLength} characters`
    }
    return null
  },
}
